/* eslint-disable no-param-reassign */
import axios from 'axios'
// import Vue from 'vue'
const baseURL = process.env.VUE_APP_BASE_URL

export default {
   namespaced: true,
   state: {
      tahun: new Date().getFullYear(),
      refreshTimestamp: 0,
      stattistik: {
         izin_year: 0,
         izin_month: 0,
         izin_proses: 0,
      },
      perBulan: {
         tahun: new Date().getFullYear(),
         data: [],
      },
      jenisIzin: [],

   },
   actions: {
      triggerRefresh({ commit }) {
         commit('SET_REFRESH_TIMESTAMP', Date.now())
      },
      getStatistik({ commit, rootState, state }, tahun = state.tahun) {
         const selectedYear = tahun instanceof Date
            ? tahun.getFullYear()
            : Number(tahun) || new Date().getFullYear()

         commit('SET_TAHUN', selectedYear)
         rootState.isLoading = true
         return axios.get(`${baseURL}dashboard/sicantik/statistik`, {
            params: { year: selectedYear },
         }).then(
            response => {
               const data = response.data && response.data.item
                  ? response.data.item
                  : response.data
               commit('SET_STATISTIK', data || {})

               rootState.isLoading = false
               return data
            },
            () => {
               rootState.isLoading = false
            },
         )
      },
      getPerBulan({ commit, rootState, state }, tahun = state.tahun) {
         const selectedYear = tahun instanceof Date
            ? tahun.getFullYear()
            : Number(tahun) || new Date().getFullYear()

         rootState.isLoading = true
         return axios.get(`${baseURL}dashboard/sicantik/perbulan`, {
            params: { year: selectedYear },
         }).then(
            response => {
               const data = response.data || {}
               commit('SET_PER_BULAN', data)

               rootState.isLoading = false
               return data
            },
            error => {
               rootState.isLoading = false
               return Promise.reject(error)
            },
         )
      },
      getJenisIzin({ commit, state }, tahun = state.tahun) {
         const selectedYear = tahun instanceof Date
            ? tahun.getFullYear()
            : Number(tahun) || new Date().getFullYear()

         return axios.get(`${baseURL}dashboard/sicantik/jenis-izin`, {
            params: { year: selectedYear },
         }).then(
            response => {
               const data = response.data && Array.isArray(response.data.data)
                  ? response.data.data
                  : []
               commit('SET_JENIS_IZIN', data)

               return data
            },
            error => Promise.reject(error),
         )
      },
   },
   mutations: {

      SET_TAHUN(state, tahun) {
         state.tahun = tahun
      },
      SET_REFRESH_TIMESTAMP(state, timestamp) {
         state.refreshTimestamp = timestamp
      },
      SET_STATISTIK(state, data) {
         state.stattistik = {
            ...state.stattistik,
            ...data,
         }
      },
      SET_PER_BULAN(state, data) {
         state.perBulan = {
            tahun: data.tahun || state.tahun,
            data: Array.isArray(data.data) ? data.data : [],
         }
      },
      SET_JENIS_IZIN(state, data) {
         state.jenisIzin = Array.isArray(data) ? data : []
      },

   },
}
